// src/components/Chat/shared/DeletedMessagePlaceholder.tsx
// Placeholder visual para mensagens deletadas

import { motion } from "framer-motion";
import { Ban } from "lucide-react";
import { useTranslation } from "react-i18next";

interface DeletedMessagePlaceholderProps {
  timestamp: string;
  isOwnMessage?: boolean;
}

export function DeletedMessagePlaceholder({
  timestamp,
  isOwnMessage = false,
}: DeletedMessagePlaceholderProps) {
  const { t } = useTranslation();

  const formatTime = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString("pt-BR", {
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      className={`flex ${isOwnMessage ? "justify-end" : "justify-start"}`}
    >
      <div
        className={`max-w-[70%] px-4 py-2.5 rounded-2xl ${
          isOwnMessage
            ? "bg-gray-200 rounded-br-md"
            : "bg-gray-100 rounded-bl-md"
        }`}
      >
        <div className="flex items-center gap-2 text-gray-500">
          <Ban size={14} className="flex-shrink-0" />
          <span className="text-sm italic">
            {t("chatFeatures.delete.deleted")}
          </span>
        </div>
        <div className="flex justify-end mt-1">
          <span className="text-[10px] text-gray-400">
            {formatTime(timestamp)}
          </span>
        </div>
      </div>
    </motion.div>
  );
}

export default DeletedMessagePlaceholder;
